import * as fetchSurveyHelper from './fetchSurvey';
import * as submitSurveyHelper from './submitSurvey';

export default {
    ...fetchSurveyHelper,
    ...submitSurveyHelper,
};